export enum ESigneEmergence {
    Forte = 1,
    Moderee = 2,
    Faible = 3,
    Absente = 4
}